import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect } from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  TextField,
  Box,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import {
  Reports,
  resetFilters,
  setFilters,
} from "../../../app/slices/reportsSlice";
import dayjs from "dayjs";
import { SelectDepartment } from "../../../components/Selects/SelectDepartment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DateRangePicker } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const TicketsDurationsSummaryFilters = () => {
  const dispatch = useDispatch();
  const {
    filters: { ticketsDurationsSummary },
  } = useSelector((state) => state.reports);

  useEffect(() => {
    return () => dispatch(resetFilters({ type: "ticketsDurationsSummary" }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h6" component="div">
            Tickets Duration Summary
          </Typography>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            {/* <Typography sx={{ mb: 1 }}>Created filter</Typography> */}
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              localeText={{ start: "From-Date", end: "To-Date" }}
            >
              <DateRangePicker
                value={[
                  ticketsDurationsSummary.start_created_at,
                  ticketsDurationsSummary.end_created_at,
                ]}
                onChange={(newValue) => {
                  dispatch(
                    setFilters({
                      type: "ticketsDurationsSummary",
                      data: {
                        start_created_at: newValue[0]
                          ? dayjs(newValue[0]).format("YYYY-MM-DD")
                          : null,
                        end_created_at: newValue[1]
                          ? dayjs(newValue[1]).format("YYYY-MM-DD")
                          : null,
                      },
                    })
                  );
                }}
                renderInput={(startProps, endProps) => (
                  <>
                    <TextField {...startProps} size="small" />
                    <Box sx={{ mx: 2 }}> to </Box>
                    <TextField {...endProps} size="small" />
                  </>
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <SelectDepartment
              fullWidth
              onChange={(e, value) => {
                dispatch(
                  setFilters({
                    type: "ticketsDurationsSummary",
                    data: { department_id: value ? value.id : null },
                  })
                );
              }}
            />
          </Grid>
          <Grid item xs={5}>
            <ToggleButtonGroup
              color="primary"
              size="small"
              value={ticketsDurationsSummary.is_resolved}
              exclusive
              onChange={(e, value) => {
                dispatch(
                  setFilters({
                    type: "ticketsDurationsSummary",
                    data: { is_resolved: value },
                  })
                );
              }}
            >
              <ToggleButton value={true}>Resolved</ToggleButton>
              <ToggleButton color="warning" value={false}>
                Unresolved
              </ToggleButton>
              <ToggleButton color="error" value={null}>
                All
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          <Grid item xs={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                dispatch(Reports.fetch("ticketsDurationsSummary"));
              }}
              sx={{
                textTransform: "capitalize",
              }}
            >
              Show results
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TicketsDurationsSummaryFilters;
